import { Param } from "./param";

export class ObjectOperation {
    public __classname__: string = 'ObjectOperation';

    public Id : string | null = null;
	public Name : string | null = null;
	public Type : string | null = null;
	public Params : Param[] | null = null;

    constructor(
        Id : string | null = null, 
        Name : string | null = null, 
        Type : string | null = null, 
        Params : Param[] | null = null
    ) {
        this.Id = Id;
        this.Name = Name;
        this.Type = Type;
        this.Params = Params;
    }
}